/**
 * Weekly business-hours schedule evaluated in the site's timezone.
 *
 * Rows are flattened into windows measured in minutes from Sunday 00:00, which
 * lets windows that run past midnight be compared the same way as any other.
 */
window.TrimarkBusinessHours = (function () {
	var WEEK = 7 * 1440;
	var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

	function toMinutes(value) {
		var parts = String(value || '').split(':');

		if (parts.length !== 2) {
			return null;
		}

		var hours = Number(parts[0]);
		var minutes = Number(parts[1]);
		var isValid =
			hours % 1 === 0 && minutes % 1 === 0 && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;

		return isValid ? hours * 60 + minutes : null;
	}

	function normalize(rows) {
		var windows = [];

		if (!Array.isArray(rows)) {
			return windows;
		}

		rows.forEach(function (row) {
			var start = toMinutes(row && row.start);
			var end = toMinutes(row && row.end);

			// Equal times would describe either a closed or a 24-hour window; the
			// field validation rejects them, so treat them as unusable here.
			if (start === null || end === null || start === end) {
				return;
			}

			var length = end > start ? end - start : end + 1440 - start;
			var days = Array.isArray(row.days) ? row.days : [];

			days.forEach(function (value) {
				var day = Number(value);

				if (day % 1 !== 0 || day < 0 || day > 6) {
					return;
				}

				windows.push({ opensAt: day * 1440 + start, length: length });
			});
		});

		return windows;
	}

	function nowInWeek(timeZone, when) {
		var date = when || new Date();

		// Sites set to a manual UTC offset rather than a city report "+05:00",
		// which Intl rejects. Those sites do not observe DST, so a fixed shift is
		// exact.
		var offset = /^([+-])(\d{2}):(\d{2})$/.exec(String(timeZone || ''));

		if (offset) {
			var shift = (Number(offset[2]) * 60 + Number(offset[3])) * (offset[1] === '-' ? -1 : 1);
			var shifted = new Date(date.getTime() + shift * 60000);

			return shifted.getUTCDay() * 1440 + shifted.getUTCHours() * 60 + shifted.getUTCMinutes();
		}

		try {
			var parts = new Intl.DateTimeFormat('en-US', {
				timeZone: timeZone,
				weekday: 'short',
				hour: '2-digit',
				minute: '2-digit',
				hourCycle: 'h23',
			})
				.formatToParts(date)
				.reduce(function (values, part) {
					values[part.type] = part.value;
					return values;
				}, {});

			if (!Object.prototype.hasOwnProperty.call(WEEKDAYS, parts.weekday)) {
				return null;
			}

			return WEEKDAYS[parts.weekday] * 1440 + (Number(parts.hour) % 24) * 60 + Number(parts.minute);
		} catch (error) {
			return null;
		}
	}

	return {
		normalize: normalize,

		/**
		 * @returns {boolean|null} null when the site timezone cannot be read.
		 */
		isOpen: function (windows, timeZone, date) {
			var now = nowInWeek(timeZone, date);

			if (now === null) {
				return null;
			}

			return windows.some(function (window) {
				return (now - window.opensAt + WEEK) % WEEK < window.length;
			});
		},

		/**
		 * @returns {number|null} Minutes until the schedule next opens or closes.
		 */
		minutesUntilChange: function (windows, timeZone, date) {
			var now = nowInWeek(timeZone, date);

			if (now === null) {
				return null;
			}

			var soonest = WEEK;

			windows.forEach(function (window) {
				[window.opensAt, window.opensAt + window.length].forEach(function (point) {
					var delta = (point - now + WEEK) % WEEK;

					if (delta > 0 && delta < soonest) {
						soonest = delta;
					}
				});
			});

			return soonest;
		},
	};
})();
